@if (canOrder) {
  <div class="content">
    <h2>{{"CUSTOMIZER.COMPONENTS.ORDEROVERVIEW.CONFIRM" | translate}}</h2>
    <p>{{"CUSTOMIZER.COMPONENTS.ORDEROVERVIEW.CONFIRMINFO" | translate}}</p>
    <p>{{"CUSTOMIZER.COMPONENTS.ORDEROVERVIEW.CONFIRMPROCEEDINFO" | translate}}</p>
    <div class="text-center form-group">
      <button class="btn btn-secondary" (click)="back()">{{"CUSTOMIZER.COMPONENTS.ORDEROVERVIEW.BACKOVERVIEW" | translate}}</button>
      <button class="btn btn-primary" (click)="placeOrder()">{{"CUSTOMIZER.COMPONENTS.ORDEROVERVIEW.CONFIRM" | translate}}</button>
    </div>
  </div>
}

@if (!canOrder) {
  <div class="content">
    <h2>{{"CUSTOMIZER.COMPONENTS.ORDEROVERVIEW.CONFIRM" | translate}}</h2>
    <p>{{"CUSTOMIZER.COMPONENTS.ORDEROVERVIEW.CONFIRMTESTORDERINFO" | translate}}</p>
    <p>{{"CUSTOMIZER.COMPONENTS.ORDEROVERVIEW.CONFIRMTESTORDERINFO2" | translate}}</p>
    <p>{{"CUSTOMIZER.COMPONENTS.ORDEROVERVIEW.CONFIRMTESTORDERPROCEEDINFO" | translate}}</p>
    <div class="text-center form-group">
      <button class="btn btn-secondary" (click)="back()">{{"CUSTOMIZER.COMPONENTS.ORDEROVERVIEW.BACKOVERVIEW" | translate}}</button>
      <button class="btn btn-primary" (click)="placeOrder()">{{"CUSTOMIZER.COMPONENTS.ORDEROVERVIEW.CONFIRM" | translate}}</button>
    </div>
  </div>
}